import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Project } from '../project.model';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../environments/environment';
import { Users } from '../model/structures';
@Injectable({ providedIn: 'root' })
export class ProjectService {
  apiurl_project_get_security_levels = environment.servers[environment.srv_mode].host + '/api/projects/security_levels';
  apiurl_project_get_entity_structures = environment.servers[environment.srv_mode].host + '/api/projects/entity_structures';
  apiurl_project_stands_by_id = environment.servers[environment.srv_mode].host + '/api/projects/stands';
  apiurl_project_gant = environment.servers[environment.srv_mode].host + '/api/projects/gant';
  apiurl_project_reverse_archivation = environment.servers[environment.srv_mode].host + '/api/projects/reverse_archivation';
  apiurl_project_custom_calc_list = environment.servers[environment.srv_mode].host + '/api/projects/custom_calc/list';
  apiurl_project_custom_calc_get_by_id = environment.servers[environment.srv_mode].host + '/api/projects/custom_calc/get_by_id';
  apiurl_project_custom_calc_create = environment.servers[environment.srv_mode].host + '/api/projects/custom_calc/create';
  apiurl_project_custom_calc_update = environment.servers[environment.srv_mode].host + '/api/projects/custom_calc/update';
  apiurl_project_custom_calc_toggle_archivation = environment.servers[environment.srv_mode].host + '/api/projects/custom_calc/toggle_archivation';
  apiurl_project = environment.servers[environment.srv_mode].host + '/api/projects';
  constructor(private http: HttpClient,private storageService: AuthenticationService) {}
  private current_user: Users = new Users();

ProjectGetSecurityLevels(): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_get_security_levels, {user: this.current_user, jwt: _token });
  }
   ProjectGetEntityStructures(): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_get_entity_structures, {user: this.current_user, jwt: _token });
  }
  ProjectGetStandsById(_id:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_get_entity_structures, {ID:_id, user: this.current_user, jwt: _token });
  }
  ProjectGant(_id:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_gant, {ID:_id, user: this.current_user, jwt: _token });
  }
  ProjectreverseGant(_id:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_reverse_archivation, {ID:_id, user: this.current_user, jwt: _token });
  }
  ProjectCustomCalclist(): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_custom_calc_list, {user: this.current_user, jwt: _token });
  }
 
  ProjectCustomCalcGetByID(_id:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_custom_calc_get_by_id, {ID:_id, user: this.current_user, jwt: _token });
  }
  ProjectCustomCalcGetCreate(_config:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_custom_calc_create, {config:_config, user: this.current_user, jwt: _token });
  }
   ProjectCustomCalcUpdate(_calc:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_custom_calc_update, {calc:_calc, user: this.current_user, jwt: _token });
  }
   ProjectCustomCalcArchivation(_calc:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project_custom_calc_toggle_archivation, {calc:_calc, user: this.current_user, jwt: _token });
  }
  ProjectPost(_ShortTitle:any, _Description:any, _StartDate:any, _EndDate:any, _Customer:any, _Executor:any, _SecurityLevelID:any, _ID:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.post<any>(this.apiurl_project, {ShortTitle:_ShortTitle, Description:_Description, StartDate:_StartDate, EndDate:_EndDate, Customer:_Customer, Executor:_Executor, SecurityLevelID:_SecurityLevelID, ID:_ID, user: this.current_user, jwt: _token });
  }
  ProjectPatch(_ShortTitle:any, _Description:any, _StartDate:any, _EndDate:any, _Customer:any, _Executor:any, _SecurityLevelID:any, _ID:any): Observable<any> {
    this.current_user = this.storageService.getUser();
    let _token = this.storageService.getToken();
    return this.http.patch<any>(this.apiurl_project, {ShortTitle:_ShortTitle, Description:_Description, StartDate:_StartDate, EndDate:_EndDate, Customer:_Customer, Executor:_Executor, SecurityLevelID:_SecurityLevelID, ID:_ID, user: this.current_user, jwt: _token });
  }


  
  getProjects(): Observable<Project[]> {
    return this.http.get<Project[]>('/api/projects');
  }

  createProject(project: Project): Observable<Project> {
    return this.http.post<Project>('/api/projects', project);
  }

  updateProject(project: Project): Observable<Project> {
    return this.http.put<Project>(`'/api/projects/'+${project.id}`, project);
  }
}
